<template>
    <SettingsCard id="block-statistics" title="Показатели сотрудника" class="ds-settings-block">
        <template v-if="editor.statisticsReady.value" #actions>
            <span class="ds-settings-muted">{{ enabledCount }} из {{ STATISTIC_FIELDS.length }}</span>
        </template>

        <SettingsBlockState
            :status="editor.load.statistics"
            :rows="5"
            error-text="Не удалось загрузить показатели сотрудника."
            @retry="editor.loadStatistics()"
        >
            <div class="ds-settings-stats-grid">
                <div v-for="(column, columnIndex) in columns" :key="columnIndex" class="ds-settings-stats-column">
                    <div
                        v-for="field in column"
                        :id="`setting-${field.key}`"
                        :key="field.key"
                        class="ds-settings-stat"
                        :class="{
                            'is-changed': editor.changedAnchors.value.has(`setting-${field.key}`),
                            'is-highlighted': editor.highlightedAnchor.value === `setting-${field.key}`,
                        }"
                    >
                        <BooleanSwitch
                            :model-value="editor.statisticValue(field.key)"
                            :disabled="editor.saving.value"
                            @update:model-value="editor.setStatistic(field.key, $event)"
                        >
                            <span class="ds-settings-code">{{ field.code }}</span>
                            <span>{{ field.label }}</span>
                        </BooleanSwitch>
                    </div>
                </div>
            </div>

            <!-- Предпросмотр черновика: порядок — порядок полей настроек (порядок «Расписания» задаёт ответ сервера). -->
            <div class="ds-settings-card-footer">
                <span class="ds-settings-muted ds-settings-nowrap">В «Расписании»:</span>
                <div v-if="enabledFields.length" class="ds-settings-codes">
                    <span v-for="field in enabledFields" :key="field.key" class="ds-settings-code ds-settings-code-outline" :title="field.label">{{ field.code }}</span>
                </div>
                <span v-else class="ds-settings-muted">показатели не выводятся</span>
            </div>
        </SettingsBlockState>
    </SettingsCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import SettingsCard from '@/ui/SettingsCard.vue'
import BooleanSwitch from '@/ui/BooleanSwitch.vue'
import SettingsBlockState from './SettingsBlockState.vue'
import { useSettingsEditor } from './useSettingsEditor'
import { STATISTIC_FIELDS } from './settingsModel'

const editor = useSettingsEditor()

const columns = [STATISTIC_FIELDS.slice(0, 5), STATISTIC_FIELDS.slice(5)]
const enabledFields = computed(() => STATISTIC_FIELDS.filter((field) => editor.statisticValue(field.key)))
const enabledCount = computed(() => enabledFields.value.length)
</script>
